import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "../../../../components/InputField";
import SelectField from "../../../../components/SelectField";
import Button from "../../../../components/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Modal } from "react-bootstrap";
import "../../Common/form.css";
import Select from "react-select";
import api from "../../../../api/api";
import { useAuth } from "../../../../context/AuthContext";
 import BackButton from "../../../../components/BackButton";
const CreateEnquiry = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
 
  const [ports, setPorts] = useState([]);
  const [loadingPorts, setLoadingPorts] = useState(true);
 
  const [tableData, setTableData] = useState([]);
  const [inputRow, setInputRow] = useState({
    containerType: "",
    weight: "",
    length: "",
    breadth: "",
    height: "",
    temperature: "",
  });
 
  // main form state
  const [formData, setFormData] = useState({
    client_name: "",
    client_company: "",
    incoterm: "",
    pol: "",
    pod: "",
    freight_terms: "",
    hs_code: "",
    hs_description: "",
    first_shipper_name: "",
    first_consignee_name: "",
    routing: "",
    transshipment_hub: "",
    nature_of_cargo: "",
    packaging_type: "",
    packageCount: "",
    cha_required: "",
    remarks: "",
    place_of_receipt: "",
    place_of_receipt_pin: "",
    final_port_of_delivery: "",
    final_port_of_delivery_pin: "",
    shipment_segment: "",
    stuffing: "",
    destuffing: "",
    document_type: "",
    document_count: "",
    switch_bl: "",
    switch_at: "",
    haz_class: "",
    goods_value: "",
  });
 
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
 
  const incoterms = [
    "Port to Port",
    "Door to Door",
    "Door to Port",
    "Port to Door",
    "ICD to Port",
    "ICD to Door",
  ];
  const shipment_segments = ["FE", "LE", "LI", "FI"];
  const routing_options = ["Direct", "Indirect", "Both"];
  const freight_terms = ["Prepaid", "Collect"];
  const containerTypes = [
    "20'Standard",
    "20'Open Top",
    "20'Reefer",
    "20'Flat Rack",
    "20'Platform",
    "20'Flexi Tank",
    "20'ISO Tank",
    "20'Hard Top",
    "20'Collapsible",
    "40'Standard",
    "40'High Cube",
    "40'Open top",
    "40'Reefer",
    "40'Flat Rack",
    "40'Platform",
    "40'Flexi Tank",
    "40'ISO Tank",
    "40'Hard Top",
    "40'Collapsible Flat Rack",
  ];
 
  useEffect(() => {
    const fetchPorts = async () => {
      try {
        setLoadingPorts(true);
        const response = await api.get("/ports");
        const allPorts = response.data;
        setPorts(allPorts);
      } catch (err) {
        console.error("Failed to fetch ports:", err);
      } finally {
        setLoadingPorts(false);
      }
    };
 
    fetchPorts();
  }, []);
 
  const portOptions = ports.map((port) => port.Port_names);
  const containerOptions = containerTypes.map((type) => ({
    value: type,
    label: type,
  }));
 
  // ---------------- Field Change Handlers ----------------
  const handleInputChange = (field, value) => {
    setInputRow((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };
 
  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };
 
  // ---------------- Table Row Handlers ----------------
  const handleAddRow = () => {
    const { containerType, weight, length, breadth, height, temperature } =
      inputRow;
    const requiresTemp = formData.nature_of_cargo === "Temperature Control";
 
    // required validation for each container row
    const missingFields = [];
    if (
      !["LE", "LI"].includes(formData.shipment_segment) &&
      !containerType
    ) {
      missingFields.push("Container Type");
    }
    // weight can be optional, but you can enforce as needed
    if (requiresTemp && (temperature === "" || temperature === null))
      missingFields.push("Temperature");
 
    if (missingFields.length > 0) {
      setErrors((prev) => ({
        ...prev,
        tableData: `Please fill: ${missingFields.join(", ")}`,
      }));
      return;
    }
 
    // Default empty numeric fields to 0
    const normalizedRow = {
      containerType,
      weight: weight || 0,
      length: length || 0,
      breadth: breadth || 0,
      height: height || 0,
      temperature: temperature || 0,
    };
 
    setTableData((prev) => [...prev, normalizedRow]);
    setInputRow({
      containerType: "",
      weight: "",
      length: "",
      breadth: "",
      height: "",
      temperature: "",
    });
    if (errors.tableData) {
      setErrors((prev) => ({ ...prev, tableData: "" }));
    }
  };
 
  const handleRemoveRow = (index) => {
    setTableData((prev) => prev.filter((_, i) => i !== index));
  };
 
  // ---------------- Validation ----------------
  const validate = () => {
    const err = {};
 
    // Only require client fields for Admin / SuperAdmin
    if (user?.user_role === "SuperAdmin" || user?.user_role === "Admin") {
      if (!formData.client_name) err.client_name = "Client Name is required";
      if (!formData.client_company)
        err.client_company = "Company Name is required";
    }
 
    if (!formData.incoterm) err.incoterm = "Incoterm is required";
    if (!formData.pol) err.pol = "Port of Loading is required";
    if (!formData.pod) err.pod = "Port of Discharge is required";
    if (!formData.freight_terms)
      err.freight_terms = "Freight Terms is required";
    if (!formData.hs_description)
      err.hs_description = "HS Description is required";
    if (!formData.routing)
      err.routing = "Routing is required";
    if (
      formData.routing === "Indirect" &&
      !formData.transshipment_hub
    )
      err.transshipment_hub = "Transshipment Hub is required";
    if (!formData.first_shipper_name)
      err.first_shipper_name = "Shipper Name is required";
    if (!formData.first_consignee_name)
      err.first_consignee_name = "Consignee Name is required";
    if (!formData.packaging_type)
      err.packaging_type = "Packaging Type is required";
    if (!formData.packageCount)
      err.packageCount = "Packaging Count is required";
    if (!formData.cha_required)
      err.cha_required = "CHA Required field is required";
    if (!formData.goods_value) err.goods_value = "Goods  Value is required";
    // Place Of Receipt / Final Port Of Delivery validation
    const inc = formData.incoterm;
    if (inc === "Door to Door") {
      if (!formData.place_of_receipt) err.place_of_receipt = "Place Of Receipt is required";
      if (!formData.place_of_receipt_pin)
        err.place_of_receipt_pin = "POR Pin Code is required";
      if (!formData.final_port_of_delivery) err.final_port_of_delivery = "Final Port Of Delivery is required";
      if (!formData.final_port_of_delivery_pin)
        err.final_port_of_delivery_pin = "FPOD Pin Code is required";
    } else if (inc === "Door to Port") {
      if (!formData.place_of_receipt) err.place_of_receipt = "Place Of Receipt is required";
      if (!formData.place_of_receipt_pin)
        err.place_of_receipt_pin = "POR Pin Code is required";
      if (!formData.final_port_of_delivery) err.final_port_of_delivery = "Final Port Of Delivery is required";
    } else if (inc === "Port to Door") {
      if (!formData.place_of_receipt) err.place_of_receipt = "Place Of Receipt is required";
      if (!formData.final_port_of_delivery) err.final_port_of_delivery = "Final Port Of Delivery is required";
      if (!formData.final_port_of_delivery_pin)
        err.final_port_of_delivery_pin = "FPOD Pin Code is required";
    } else if (inc === "ICD to Door") {
      if (!formData.place_of_receipt) err.place_of_receipt = "Place Of Receipt is required";
      if (!formData.final_port_of_delivery) err.final_port_of_delivery = "Final Port Of Delivery is required";
      if (!formData.final_port_of_delivery_pin)
        err.final_port_of_delivery_pin = "FPOD Pin Code is required";
    } else if (inc === "ICD to Port" || inc === "Port to Port") {
      if (!formData.place_of_receipt) err.place_of_receipt = "Place Of Receipt is required";
      if (!formData.final_port_of_delivery) err.final_port_of_delivery = "Final Port Of Delivery is required";
    }
 
    // Shipment segment checks
    if (!formData.shipment_segment)
      err.shipment_segment = "Shipment Segment is required";
    if (["FE", "LE"].includes(formData.shipment_segment) && !formData.stuffing)
      err.stuffing = "Stuffing location is required";
    if (
      ["LI", "FI"].includes(formData.shipment_segment) &&
      !formData.destuffing
    )
      err.destuffing = "Destuffing location is required";
 
    // Nature of cargo
    if (!formData.nature_of_cargo)
      err.nature_of_cargo = "Nature of Cargo is required";
    if (formData.nature_of_cargo === "Hazardous" && !formData.haz_class)
      err.haz_class = "HAZ Class is required";
 
    // Container details validation
    if (
      !["LE", "LI"].includes(formData.shipment_segment) &&
      (!tableData || tableData.length === 0)
    ) {
      err.tableData = "At least one container detail is required";
    }
 
    // Document validation
    if (!formData.document_type)
      err.document_type = "Document Type is required";
    if (formData.document_type === "Original" && !formData.document_count)
      err.document_count = "Document count is required";
    if (formData.switch_bl === "Yes" && !formData.switch_at)
      err.switch_at = "Switch At is required";
 
    setErrors(err);
    return Object.keys(err).length === 0;
  };
 
  // ---------------- Form Submission ----------------
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setShowConfirm(true);
  };
 
  const handleConfirm = async () => {
    setShowConfirm(false);
 
    const enquiryPayload = {
      user_id: user?.user_id || "",
      pol: formData.pol,
      pod: formData.pod,
      place_of_receipt: formData.place_of_receipt,
      place_of_receipt_pin: formData.place_of_receipt_pin,
      final_port_of_delivery: formData.final_port_of_delivery,
      final_port_of_delivery_pin: formData.final_port_of_delivery_pin,
      shipment_segment: formData.shipment_segment,
      hs_code: formData.hs_code,
      hs_description: formData.hs_description,
      first_shipper_name: formData.first_shipper_name,
      first_consignee_name: formData.first_consignee_name,
      routing: formData.routing,
      transshipment_hub: formData.transshipment_hub,
      freight_terms: formData.freight_terms,
      incoterm: formData.incoterm,
      nature_of_cargo: formData.nature_of_cargo,
      haz_class: formData.haz_class,
      document_type: formData.document_type,
      document_count: formData.document_count
        ? parseInt(formData.document_count)
        : 0,
      switch_bl: formData.switch_bl,
      switch_at: formData.switch_at,
      stuffing_destuffing: ["FE", "LE"].includes(formData.shipment_segment)
        ? "Stuffing"
        : "Destuffing",
      stuffing_destuffing_At: ["FE", "LE"].includes(formData.shipment_segment)
        ? formData.stuffing
        : formData.destuffing,
      packaging_type: formData.packaging_type,
      packaging_count: formData.packageCount
        ? parseInt(formData.packageCount)
        : 0,
      goods_value: formData.goods_value ? parseFloat(formData.goods_value) : 0,
      remarks: formData.remarks,
      Status: "Enquiry created",
      Status_client: "Pending",
      CreatedBY: user?.full_name || "",
      CreatorCompany: user?.company_name || "",
      CreatorEmail: user?.email || "",
      client_name:
        user?.user_role === "SuperAdmin" || user?.user_role === "Admin"
          ? formData.client_name
          : user?.full_name || "",
      client_company:
        user?.user_role === "SuperAdmin" || user?.user_role === "Admin"
          ? formData.client_company
          : user?.company_name || "",
      cha_required: formData.cha_required,
      created_by_id: user?.user_id || "",
      notificationType: "shared",
      containers: tableData.map((c) => ({
        container_type: c.containerType,
        container_weight: c.weight ? parseFloat(c.weight) : 0,
        container_length: c.length ? parseFloat(c.length) : 0,
        container_height: c.height ? parseFloat(c.height) : 0,
        container_breadth: c.breadth ? parseFloat(c.breadth) : 0,
        container_temperature: c.temperature ? parseInt(c.temperature) : 0,
      })),
    };
 
    try {
      const response = await api.post("/enquiry/create", enquiryPayload);
      console.log("Backend result:", response.data);
      setShowSuccess(true);
    } catch (err) {
      console.error("Failed to create enquiry:", err);
      setErrors({ submit: "Failed to submit enquiry. Please try again." });
    }
  };
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    if (user?.user_role === "User") {
      navigate("/my-enquiry/view-enquiry");
    } else if (
      user?.user_role === "Admin" ||
      user?.user_role === "SuperAdmin"
    ) {
      navigate("/freight/pending-enquiries");
    } else {
      navigate("/my-enquiry/view-enquiry");
    }
  };
 
  return (
    <>
      <BackButton />
  
      <form onSubmit={handleSubmit}>
<div className="row mb-3 g-3">
          {(user?.user_role === "SuperAdmin" ||
            user?.user_role === "Admin" ||
            user?.user_role === "sales_rep") && (
            <>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Booking Party Name"
                  clsname="required"
                  placeholder={"Enter the Client Name"}
                  value={formData.client_name}
                  onChange={(e) =>
                    handleFormChange("client_name", e.target.value)
                  }
                  error={errors.client_name}
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Booking Company Name"
                  clsname="required"
                  placeholder={"Enter the Client's Company Name"}
                  value={formData.client_company}
                  onChange={(e) =>
                    handleFormChange("client_company", e.target.value)
                  }
                  error={errors.client_company}
                />
              </div>
            </>
          )}

          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Incoterm"
              options={incoterms}
              clsname="required"
              value={formData.incoterm}
              onChange={(val) => handleFormChange("incoterm", val)}
              error={errors.incoterm}
            />
          </div>

          {/* Shipper Name + Consignee Name */}
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Shipper Name"
              placeholder="Enter Shipper Name"
              clsname="required"
              value={formData.first_shipper_name}
              onChange={(e) =>
                handleFormChange("first_shipper_name", e.target.value)
              }
              error={errors.first_shipper_name}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Consignee Name"
              placeholder="Enter Consignee Name"
              clsname="required"
              value={formData.first_consignee_name}
              onChange={(e) =>
                handleFormChange("first_consignee_name", e.target.value)
              }
              error={errors.first_consignee_name}
            />
          </div>

          {/* Shipment Segment */}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Shipment Segment"
              options={shipment_segments}
              clsname="required"
              value={formData.shipment_segment}
              onChange={(val) => handleFormChange("shipment_segment", val)}
              error={errors.shipment_segment}
            />
          </div>

          {/* Place Of Receipt / Final Port Of Delivery */}
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Place Of Receipt"
              placeholder="Enter Place Of Receipt"
              value={formData.place_of_receipt}
              onChange={(e) => handleFormChange("place_of_receipt", e.target.value)}
              error={errors.place_of_receipt}
            />
          </div>
          {["Door to Door", "Door to Port"].includes(
            formData.incoterm
          ) && (
            <div className="col-sm-6 col-md-4">
              <InputField
                label="POR Pin Code"
                placeholder="Enter POR Pin Code"
                value={formData.place_of_receipt_pin}
                onChange={(e) =>
                  handleFormChange("place_of_receipt_pin", e.target.value)
                }
                error={errors.place_of_receipt_pin}
              />
            </div>
          )}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Port of Loading"
              options={portOptions}
              clsname="required"
              value={formData.pol}
              onChange={(val) => handleFormChange("pol", val)}
              error={errors.pol}
              isLoading={loadingPorts}
              searchable={true}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Port of Discharge"
              options={portOptions}
              clsname="required"
              value={formData.pod}
              onChange={(val) => handleFormChange("pod", val)}
              error={errors.pod}
              isLoading={loadingPorts}
              searchable={true}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Final Port Of Delivery"
              placeholder="Enter Final Port Of Delivery"
              value={formData.final_port_of_delivery}
              onChange={(e) => handleFormChange("final_port_of_delivery", e.target.value)}
              error={errors.final_port_of_delivery}
            />
          </div>
          {["Door to Door", "Port to Door", "ICD to Door"].includes(
            formData.incoterm
          ) && (
            <div className="col-sm-6 col-md-4">
              <InputField
                label="FPOD Pin Code"
                placeholder="Enter FPOD Pin Code"
                value={formData.final_port_of_delivery_pin}
                onChange={(e) =>
                  handleFormChange("final_port_of_delivery_pin", e.target.value)
                }
                error={errors.final_port_of_delivery_pin}
              />
            </div>
          )}

          <div className="col-sm-6 col-md-4 ">
            <SelectField
              label="Freight Terms"
              options={freight_terms}
              clsname="required"
              value={formData.freight_terms}
              onChange={(val) => handleFormChange("freight_terms", val)}
              error={errors.freight_terms}
            />
          </div>

          {["FE", "LE"].includes(formData.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <SelectField
                label="Stuffing At"
                options={["Factory", "Port"]}
                clsname="required"
                value={formData.stuffing}
                onChange={(val) => handleFormChange("stuffing", val)}
                error={errors.stuffing}
              />
            </div>
          )}
          {["LI", "FI"].includes(formData.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <SelectField
                label="Destuffing At"
                options={["Factory", "Port"]}
                clsname="required"
                value={formData.destuffing}
                onChange={(val) => handleFormChange("destuffing", val)}
                error={errors.destuffing}
              />
            </div>
          )}

          {/* Nature of Cargo */}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Nature of Cargo"
              options={[
                "Hazardous",
                "Non Hazardous",
                "Temperature Control",
                "Moisture Control",
                "Heavy Duty",
                "Over Dimensional Cargo",
              ]}
              clsname="required"
              value={formData.nature_of_cargo}
              onChange={(val) => handleFormChange("nature_of_cargo", val)}
              error={errors.nature_of_cargo}
            />
          </div>
          {formData.nature_of_cargo === "Hazardous" && (
            <>
              <div className="col-sm-6 col-md-4">
                <SelectField
                  label="HAZ Class"
                  options={[
                    "Class 1",
                    "Class 2",
                    "Class 3",
                    "Class 4",
                    "Class 5",
                    "Class 6",
                    "Class 7",
                    "Class 8",
                  ]}
                  clsname="required"
                  value={formData.haz_class}
                  onChange={(val) => handleFormChange("haz_class", val)}
                  error={errors.haz_class}
                />
              </div>
            </>
          )}

          {/* HS Code + Description */}
          <div className="col-sm-6 col-md-4">
            <InputField
              label="HS Code"
              placeholder="Enter HS Code"
              value={formData.hs_code}
              onChange={(e) => handleFormChange("hs_code", e.target.value)}
              error={errors.hs_code}
            />
          </div>
          <div className="col-sm-6 col-md-4 ">
            <InputField
              label="HS Description"
              placeholder="Enter Description"
              value={formData.hs_description}
              onChange={(e) =>
                handleFormChange("hs_description", e.target.value)
              }
              error={errors.hs_description}
            />
            <div className=" measurement d-inline-flex d-lg-none">
              <p>1M = 100CM</p>
              <p>1CM = 10MM</p>
            </div>
          </div>

          {/* Routing */}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Routing"
              options={routing_options}
              clsname="required"
              value={formData.routing}
              onChange={(val) => handleFormChange("routing", val)}
              error={errors.routing}
            />
          </div>
          {["Indirect", "Both"].includes(formData.routing) && (
            <div className="col-sm-6 col-md-4">
              <SelectField
                label="Transshipment Hub"
                options={portOptions}
                clsname="required"
                value={formData.transshipment_hub}
                onChange={(val) =>
                  handleFormChange("transshipment_hub", val)
                }
                error={errors.transshipment_hub}
                isLoading={loadingPorts}
                searchable={true}
              />
            </div>
          )}

          {/* Document Type */}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Document Type"
              options={["Original", "Seaway"]}
              clsname="required"
              value={formData.document_type}
              onChange={(val) => handleFormChange("document_type", val)}
              error={errors.document_type}
            />
          </div>
          {formData.document_type === "Original" && (
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Document Count"
                type="number"
                placeholder="Enter document count"
                value={formData.document_count}
                onChange={(e) =>
                  handleFormChange("document_count", e.target.value)
                }
                error={errors.document_count}
              />
            </div>
          )}
          {/* Switch BL Dropdown */}
          <div className="col-sm-6 col-md-4">
            <SelectField
              label="Switch BL"
              options={["No", "Yes"]}
              value={formData.switch_bl || "No"}
              onChange={(val) => handleFormChange("switch_bl", val)}
              error={errors.switch_bl}
            />
          </div>
          {formData.switch_bl === "Yes" && (
            <div className="col-sm-6 col-md-4">
              <SelectField
                label="Switch At"
                options={portOptions}
                value={formData.switch_at}
                onChange={(val) => handleFormChange("switch_at", val)}
                error={errors.switch_at}
                isLoading={loadingPorts}
                searchable={true}
              />
            </div>
          )}

          {/* Packaging Type + Packaging Count + Goods Value */}
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Packaging Type"
              clsname="required"
              placeholder="Enter Packaging Type"
              value={formData.packaging_type}
              onChange={(e) =>
                handleFormChange("packaging_type", e.target.value)
              }
              error={errors.packaging_type}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Packaging Count"
              type="number"
              clsname="required"
              placeholder="Enter Count"
              value={formData.packageCount}
              onChange={(e) => handleFormChange("packageCount", e.target.value)}
              error={errors.packageCount}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Goods Value"
              type="number"
              clsname="required"
              placeholder="Enter Value of Goods"
              value={formData.goods_value}
              onChange={(e) => handleFormChange("goods_value", e.target.value)}
              error={errors.goods_value}
            />
          </div>
        </div>
  
<div className="position-relative mb-4">
            <h5 className="mb-2">Cargo Dimensions</h5>
            <div className="d-flex align-items-start">
              <div className="ovrflw flex-grow-1">
              <table className="table table-bordered tbllbl mb-2 mb-md-3">
                <thead className="table-light ">
                  <tr>
                    {!["LE", "LI"].includes(formData.shipment_segment) && (
                      <th>Container Type</th>
                    )}
                    {!["LE", "LI"].includes(formData.shipment_segment) && (
                      <th>Gross Cargo Weight</th>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <th>Length</th>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <th>Breadth</th>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <th>Height</th>
                    )}
                    {["LE", "LI"].includes(formData.shipment_segment) && (
                      <th>CBM</th>
                    )}
                    {formData.nature_of_cargo === "Temperature Control" && (
                      <th>Temperature</th>
                    )}
                    <th style={{ maxWidth: "100px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {!["LE", "LI"].includes(formData.shipment_segment) && (
                      <td>
                        <Select
                          value={
                            inputRow.containerType
                              ? {
                                  value: inputRow.containerType,
                                  label: inputRow.containerType,
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleInputChange(
                              "containerType",
                              selectedOption?.value || "",
                            )
                          }
                          options={containerOptions}
                          placeholder="Select"
                          isClearable
                        />
                      </td>
                    )}
                    {!["LE", "LI"].includes(formData.shipment_segment) && (
                      <td>
                        <InputField
                          value={inputRow.weight}
                          type="number"
                          placeholder="Weight in kg's"
                          onChange={(e) =>
                            handleInputChange("weight", e.target.value)
                          }
                        />
                      </td>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <td>
                        <InputField
                          value={inputRow.length}
                          type="number"
                          placeholder="Length in cm's"
                          onChange={(e) =>
                            handleInputChange("length", e.target.value)
                          }
                        />
                      </td>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <td>
                        <InputField
                          value={inputRow.breadth}
                          type="number"
                          placeholder="Breadth in cm's"
                          onChange={(e) =>
                            handleInputChange("breadth", e.target.value)
                          }
                        />
                      </td>
                    )}
                    {!["FE", "FI"].includes(formData.shipment_segment) && (
                      <td>
                        <InputField
                          value={inputRow.height}
                          type="number"
                          placeholder="Height in cm's"
                          onChange={(e) =>
                            handleInputChange("height", e.target.value)
                          }
                        />
                      </td>
)}
                     {["LE", "LI"].includes(formData.shipment_segment) && (
                       <td>
                         {inputRow.length && inputRow.breadth && inputRow.height
                           ? (
                               (parseFloat(inputRow.length) *
                                 parseFloat(inputRow.breadth) *
                                 parseFloat(inputRow.height)) /
                               1000000
                             ).toFixed(2)
                           : "0.00"}
                       </td>
                     )}
                     {formData.nature_of_cargo === "Temperature Control" && (
                       <td>
                         <InputField
                           value={inputRow.temperature}
                           type="number"
                           placeholder="Temperature in °C"
                           onChange={(e) =>
                             handleInputChange("temperature", e.target.value)
                           }
                         />
                       </td>
                     )}
                    <td className="text-center" style={{ maxWidth: "100px" }}>
                      <AddCircleOutlineIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                          fontSize: 28,
                        }}
                        onClick={handleAddRow}
                      />
                    </td>
                  </tr>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      {!["LE", "LI"].includes(formData.shipment_segment) && (
                        <td>{row.containerType}</td>
                      )}
                      {!["LE", "LI"].includes(formData.shipment_segment) && (
                        <td>{row.weight}</td>
                      )}
                      {!["FE", "FI"].includes(formData.shipment_segment) && (
                        <td>{row.length}</td>
                      )}
                      {!["FE", "FI"].includes(formData.shipment_segment) && (
                        <td>{row.breadth}</td>
                      )}
                      {!["FE", "FI"].includes(formData.shipment_segment) && (
                        <td>{row.height}</td>
                      )}
{["LE", "LI"].includes(formData.shipment_segment) && (
                      <td>
                        {row.length && row.breadth && row.height
                          ? (
                              (parseFloat(row.length) *
                                parseFloat(row.breadth) *
                                parseFloat(row.height)) /
                              1000000
                            ).toFixed(2)
                          : "0.00"}
                      </td>
                    )}
                    {formData.nature_of_cargo === "Temperature Control" && (
                        <td>{row.temperature}</td>
                      )}
                      <td className="text-center">
                        <DeleteOutlineIcon
                          style={{
                            cursor: "pointer",
                            color: "red",
                            fontSize: 28,
                          }}
                          onClick={() => handleRemoveRow(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              <div className="measurement d-none d-lg-block ms-3 flex-shrink-0">
                <p>1M = 100CM</p>
                <p>1CM = 10MM</p>
              </div>
            </div>
            {errors.tableData && (
              <div className="invalid-feedback">{errors.tableData}</div>
            )}
          </div>
 
<div className="row mb-3">
           <div className="col-sm-6 col-md-4">
             <SelectField
               label="CHA Services Required?"
               options={["Yes", "No"]}
               clsname="required"
               value={formData.cha_required}
               onChange={(val) => handleFormChange("cha_required", val)}
               error={errors.cha_required}
             />
           </div>
           <div className="col-md-6">
             <InputField
               label="Remarks"
               placeholder="Any remarks or additional info"
               value={formData.remarks}
               onChange={(e) => handleFormChange("remarks", e.target.value)}
             />
             <p className="text-end mb-0 remark">
               {formData.remarks.length} / 500
             </p>
           </div>
           <div className="col-md-12 text-end">
             <Button type="submit" text="Create Enquiry" variant="success" />
           </div>
         </div>
      </form>
 
      {/* Confirm Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit this enquiry?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>
 
      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Enquiry submitted successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
 
export default CreateEnquiry;